export const formTypes = {
    SwitchPermission: "[Permissions] Switch permission",
    SwitchPermissionAll: "[Permissions] Switch all permission",
    FillPermision: "[Permissions] Fill permissions",
    CleanPermisions: "[Permissions] Clean permissions",
};
